import classNames from 'classnames';
import Link from 'next/link';
import StyleContextProvider from 'utils/context/StyleContextProvider';
import Text from 'components/Layout/Module/Text';
import DateComponent from 'components/Common/DateComponent';
import styles from './NewsSection.module.scss';

const NewsSection = ({
    props: {
        page,
        articles,
        blogs: { blogs },
    },
}) => {
    const pageData = page?.content,
        pageTitle = pageData?.title,
        newArticles = blogs,
        adviceLink = pageData?.adviceLink,
        adviceText = pageData?.adviceText,
        headerBackground = pageData?.headerBackground
            ? { background: pageData?.headerBackground }
            : {},
        pressInquiriesCopy = pageData?.pressInquiriesCopy.json,
        copyContent = pressInquiriesCopy.content[0].content ?? null,
        latestPost = articles[0],
        latestLink = latestPost?.link,
        arrowIcon = <>&rarr;</>;

    return (
        <StyleContextProvider styles={styles}>
            <div className={classNames(styles.container, styles.banner)}>
                <div className={styles.blogBanner} style={headerBackground}>
                    <div className={styles.newsHeading}>
                        <div className={styles.inquiry}>
                            <Text data={{ body: copyContent[0] }} />
                            <Text data={{ body: copyContent[1] }} />
                            <Text data={{ body: copyContent[2] }} />
                        </div>
                        <p className={styles.heading}>{pageTitle}</p>
                    </div>
                </div>
            </div>
            <div className={styles.container}>
                <div className={styles.latest}>
                    <div className={classNames(styles.row, styles.headerRow)}>
                        <div className={styles.col}>
                            <div className={styles.latestPostImage}>
                                <img
                                    src={latestPost.img.url}
                                    alt="Viome news"
                                />
                            </div>
                        </div>
                        <div className={styles.col}>
                            <div className={styles.articleText}>
                                <div className={styles.articleTop}>
                                    <p>{latestPost?.author}</p>
                                    <p>
                                        <DateComponent
                                            dateString={latestPost.publishDate}
                                        />
                                    </p>
                                </div>
                                <p className={styles.articleTitle}>
                                    {latestPost.title}
                                </p>
                                <p className={styles.articleLink}>
                                    <Link href={latestLink}>
                                        {latestPost.linkText}
                                        <span>&rarr;</span>
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.posts}>
                    <div className={styles.row}>
                        {articles.length &&
                            articles.map(
                                (
                                    {
                                        author,
                                        img,
                                        link,
                                        linkText,
                                        publishDate,
                                        title,
                                    },
                                    index,
                                ) =>
                                    index !== 0 && (
                                        <div className={styles.col} key={index}>
                                            <Link href={link}>
                                                <div
                                                    className={
                                                        styles.articleListItem
                                                    }
                                                >
                                                    <div
                                                        className={
                                                            styles.articleImg
                                                        }
                                                    >
                                                        {img && (
                                                            <img
                                                                src={
                                                                    img.url
                                                                }
                                                                alt={title}
                                                            />
                                                        )}
                                                    </div>
                                                    <div
                                                        className={
                                                            styles.articleBody
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                styles.articleTop
                                                            }
                                                        >
                                                            <p>{author}</p>
                                                            <p>
                                                                <DateComponent
                                                                    dateString={
                                                                        publishDate
                                                                    }
                                                                />
                                                            </p>
                                                        </div>
                                                        <p
                                                            className={
                                                                styles.articleTitle
                                                            }
                                                        >
                                                            {title}
                                                        </p>
                                                        <p
                                                            className={
                                                                styles.articleLink
                                                            }
                                                        >
                                                            {linkText}

                                                            <span>
                                                                {arrowIcon}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    ),
                            )}
                    </div>
                </div>
                <div className={styles.line} />
                <div className={classNames(styles.posts, styles.newArticles)}>
                    <p className={styles.articleTitle}>New Articles</p>
                    <div className={styles.row}>
                        {newArticles.length &&
                            newArticles.map(
                                (
                                    {
                                        date,
                                        featuredImage,
                                        subtitle,
                                        title,
                                        slug,
                                    },
                                    index,
                                ) => (
                                    <div className={styles.col} key={index}>
                                        <Link href={`/blog/${slug}`}>
                                            <div className={styles.post}>
                                                <div
                                                    className={
                                                        styles.articleImg
                                                    }
                                                >
                                                    {featuredImage &&
                                                        featuredImage?.url && (
                                                            <img
                                                                src={
                                                                    featuredImage?.url
                                                                }
                                                                alt="Viome news"
                                                            />
                                                        )}
                                                </div>
                                                <div
                                                    className={
                                                        styles.articleBody
                                                    }
                                                >
                                                    <p>{title}</p>
                                                    <p>{subtitle}</p>
                                                    <p>
                                                        <DateComponent
                                                            dateString={
                                                                date
                                                            }
                                                        />
                                                    </p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ),
                            )}
                    </div>
                </div>
                <div className={styles.advice}>
                    <div className={styles.content}>
                        <div className={styles.text}>
                            <p className={styles.adviceText}>{adviceText}</p>
                        </div>
                        <p className={styles.final}>
                            <a
                                href={adviceLink}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Learn More
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </StyleContextProvider>
    );
};

export default NewsSection;
